import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const TrelloRemoveMemberFromWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrelloRemoveMemberFromWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idOrganization"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trello"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMemberFromWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idOrganization"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"optIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"StringValue","value":"TrelloRemoveMemberFromWorkspace","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TrelloRemoveMemberFromWorkspace","document":TrelloRemoveMemberFromWorkspaceDocument}} as const;
export type TrelloRemoveMemberFromWorkspaceMutationVariables = Types.Exact<{
  idMember: Types.Scalars['ID']['input'];
  idOrganization: Types.Scalars['ID']['input'];
}>;


export type TrelloRemoveMemberFromWorkspaceMutation = (
  { __typename: 'Mutation' }
  & { trello: (
    { __typename: 'TrelloMutationApi' }
    & { removeMemberFromWorkspace?: Types.Maybe<(
      { __typename: 'TrelloRemoveMemberFromWorkspacePayload' }
      & Pick<Types.TrelloRemoveMemberFromWorkspacePayload, 'success'>
      & { errors?: Types.Maybe<Array<(
        { __typename: 'MutationError' }
        & Pick<Types.MutationError, 'message'>
      )>> }
    )> }
  ) }
);

export type TrelloRemoveMemberFromWorkspaceMutationFn = Apollo.MutationFunction<
  TrelloRemoveMemberFromWorkspaceMutation,
  TrelloRemoveMemberFromWorkspaceMutationVariables
>;

/**
 * __useTrelloRemoveMemberFromWorkspaceMutation__
 *
 * To run a mutation, you first call `useTrelloRemoveMemberFromWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrelloRemoveMemberFromWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trelloRemoveMemberFromWorkspaceMutation, { data, loading, error }] = useTrelloRemoveMemberFromWorkspaceMutation({
 *   variables: {
 *      idMember: // value for 'idMember'
 *      idOrganization: // value for 'idOrganization'
 *   },
 * });
 */
export function useTrelloRemoveMemberFromWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrelloRemoveMemberFromWorkspaceMutation,
    TrelloRemoveMemberFromWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrelloRemoveMemberFromWorkspaceMutation,
    TrelloRemoveMemberFromWorkspaceMutationVariables
  >(TrelloRemoveMemberFromWorkspaceDocument, options);
}
export type TrelloRemoveMemberFromWorkspaceMutationHookResult = ReturnType<
  typeof useTrelloRemoveMemberFromWorkspaceMutation
>;
export type TrelloRemoveMemberFromWorkspaceMutationResult =
  Apollo.MutationResult<TrelloRemoveMemberFromWorkspaceMutation>;
export type TrelloRemoveMemberFromWorkspaceMutationOptions =
  Apollo.BaseMutationOptions<
    TrelloRemoveMemberFromWorkspaceMutation,
    TrelloRemoveMemberFromWorkspaceMutationVariables
  >;
